import { render, staticRenderFns } from "./r-trader-offer-group.vue?vue&type=template&id=58398540"
import script from "./r-trader-offer-group.vue?vue&type=script&lang=js"
export * from "./r-trader-offer-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58398540')) {
      api.createRecord('58398540', component.options)
    } else {
      api.reload('58398540', component.options)
    }
    module.hot.accept("./r-trader-offer-group.vue?vue&type=template&id=58398540", function () {
      api.rerender('58398540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trader/r-trader-offer-group.vue"
export default component.exports